let cachedSessionId: string | null = null;

/**
 * Initializes and caches a session ID that persists for the duration of the user's session.
 * The session ID is a concatenation of the user ID and the unix timestamp (in milliseconds)
 * when the session was initialized.
 *
 * @param userId - The user's numeric ID from their training instance
 * @returns The session ID string
 */
export const initializeSessionId = (userId: number): string => {
  if (cachedSessionId === null) {
    const timestamp = Date.now();
    cachedSessionId = `${userId}${timestamp}`;
  }
  return cachedSessionId;
};

/**
 * Gets the current session ID. Returns null if the session has not been initialized.
 */
export const getSessionId = (): string | null => {
  return cachedSessionId;
};

/**
 * Caches a server-issued AI chat session ID.
 */
export const setSessionId = (sessionId: string): void => {
  cachedSessionId = sessionId;
};

/**
 * For testing purposes only - resets the cached session ID
 */
export const resetSessionId = (): void => {
  cachedSessionId = null;
};
